import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const useGridState = props => {
  const {
    resource,
    getGridState,
    setGridState
  } = props;

  // flag to disable gridState if needed
  const disabled = false;

  const account = useSelector(state => state.portalReducer.account);

  const [state, setState] = useState({
    loading: true,
    gridState: null
  });

  useEffect(async () => {
    if (disabled) {
      setState(state => ({ ...state, loading: false }));
      return;
    }

    let gridState = props.gridState; // might be null
    if (!gridState) {
      // get grid state if it exists
      try {
        gridState = await getGridState(account.id, resource);
      } catch(err) {
        // ignore
      }
    }

    setState(state => ({
      ...state,
      loading: false,
      gridState
    }));
  }, []);

  let columnOrder = state.gridState?.column_order || props.columnOrder;
  let setColumnOrder = async value => {
    let params = { column_order: value };
    let gridState = await setGridState(account.id, resource, params);

    setState(state => ({ ...state, gridState }));
  }

  let visibleColumns = state.gridState?.visible_columns || props.visibleColumns;
  let setVisibleColumns = async value => {
    let params = { visible_columns: value };
    let gridState = await setGridState(account.id, resource, params);

    setState(state => ({ ...state, gridState }));
  }

  let pinnedColumns = state.gridState?.pinned_columns;
  let setPinnedColumns = async value => {
    let params = { pinned_columns: value };
    let gridState = await setGridState(account.id, resource, params);

    setState(state => ({ ...state, gridState }));
  }

  return {
    disabled,
    loading: state.loading,
    columnOrder,
    setColumnOrder,
    visibleColumns,
    setVisibleColumns,
    pinnedColumns,
    setPinnedColumns
  }
}

export default useGridState;
